import styled from "styled-components";
import {
  MwebListContent,
  MwebLoaderWrap,
  MwebPageRoot,
  MwebScrollArea,
  MwebSpinner,
} from "../CommonLandingMweb/shared/MwebPageShell";

export const PageRoot = styled(MwebPageRoot)`
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
`;

export const ScrollArea = styled(MwebScrollArea)`
  padding-bottom: calc(88px + env(safe-area-inset-bottom));
`;

export const ListContent = MwebListContent;

export const CardWrap = styled.div`
  padding: 0 16px;
`;

export const LoaderWrap = MwebLoaderWrap;

/** Toast stack spacing for MWeb traveller review (parity with desktop V2). */
export const WebToastWrap = styled.div`
  div {
    height: 40px;
  }
`;

export const Spinner = MwebSpinner;
